const getIllustrationHeaderColor = (variant) => {
    switch (variant) {
        case "error":
            return "semantic.illustration.background6";
        case "warning":
            return "semantic.illustration.background5";
        case "success":
            return "semantic.illustration.background3";
        case "info":
        default:
            return "semantic.illustration.background4";
    }
};
export { getIllustrationHeaderColor };
//# sourceMappingURL=Modal.helpers.js.map